/* eslint-disable functional/immutable-data */
import { useEffect, useRef } from "react";
import { useCallback } from "react";
import { useState } from "react";

const SVG_ANIMATION_INTERVAL_MS = 250;

const useIconAnimation = (
  numberOfStates: number,
): {
  currentState: number;
  activate: () => void;
  stop: () => void;
  isActive: boolean;
} => {
  const [isActive, setIsActive] = useState<boolean>(false);
  const [currentState, setCurrentState] = useState<number>(0);
  const intervalRef = useRef<number | null>(null);
  const activate = useCallback((): void => {
    setIsActive(true);
  }, []);
  const stop = useCallback((): void => {
    setIsActive(false);
  }, []);

  useEffect((): (() => void) => {
    if (isActive) {
      intervalRef.current = window.setInterval((): void => {
        setCurrentState((prev: number): number => (prev + 1) % numberOfStates);
      }, SVG_ANIMATION_INTERVAL_MS);
    } else {
      setCurrentState(0);
      if (intervalRef.current !== null) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }

    return (): void => {
      if (intervalRef.current !== null) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [isActive, numberOfStates]);

  return {
    activate,
    currentState,
    isActive,
    stop,
  };
};

export { useIconAnimation };
